// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type BaustellenInfo } from "../../api";
import { useGetBaustelle as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useBaustelle(
  id: string,
  options: Omit<
    UseQueryOptions<BaustellenInfo, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): BaustellenInfo {
  const getter = useGetter();
  return useQuery(["baustellen", id], () => getter(id), options).data!;
}
